"use strict";

const {
  resolve
} = require('./Util');

const NODE_TYPE = 'layoutNode';
/**
 * Given an array of objects, this will create either an array of layout nodes or 
 * a layout tree, depending on the value of options.buildTree.
 * @param {Array} arr the objects to sort/treeify
 * @param {Object} [opts] the options
 * @param {boolean} opts.buildTree if this false, an array will be returned. If
 * true( the default), a layout tree will be returned. Each layout node in 
 * the tree looks like { type : 'layoutNode', name : <string|null>, items : [ ] }. 
 * The items array in the node will contain either layout nodes or items from 
 * the given array. The string 'layoutNode' is captured in Layout.NODE_TYPE
 */

function create(arr, options) {
  const {
    sorter = defaultSorter,
    buildTree
  } = options || {};
  const refs = arr.map(item => getLayoutNode(item));
  refs.sort(sorter);

  if (buildTree !== false) {
    return toTree(refs);
  }

  return refs.map(r => r.item);
}
/**
 * Returns a node with thes sort key and group already resolved
 * and ready for use in the sorting and tree construction
 */


function getLayoutNode(item) {
  if (item.layout) {
    let {
      sort,
      group,
      groupNames,
      groupIcons
    } = item.layout;
    sort = resolve(sort || item.name || item.type || '_z');
    group = resolve(group) || [];
    groupNames = resolve(groupNames) || [];
    groupIcons = resolve(groupIcons) || [];
    const groupKey = group == null ? '/' : `/${group.join('/')}`;
    return {
      sort,
      group,
      groupNames,
      groupIcons,
      groupKey,
      item
    };
  }

  return {
    sort: resolve(item.name || item.type || '_z'),
    group: [],
    groupKey: '/',
    groupNames: [],
    groupIcons: [],
    item
  };
}

function ensurePath(grps, path, names, icons) {
  const key = path.join('/');
  const len = path.length;
  let node = grps.get(key);
  const nameIsGroup = len > 0 && (names == null || names[len - 1] == null);

  if (node == null) {
    node = {
      type: NODE_TYPE,
      name: len === 0 ? null : nameIsGroup ? path[len - 1] : names[len - 1],
      icon: len === 0 || icons == null ? null : icons[len - 1] || null,
      nameIsGroup,
      items: []
    };
    grps.set(key, node);
    const parent = ensurePath(grps, path.slice(0, len - 1), names === null || names === void 0 ? void 0 : names.slice(0, len - 1), icons === null || icons === void 0 ? void 0 : icons.slice(0, len - 1));
    parent.items.push(node);
  } else if (len > 0 && (names || icons)) {
    // Apply explicit group names and icons 
    let c = '';

    for (let n = 0; n < path.length; n++) {
      c = n === 0 ? path[n] : `${c}/${path[n]}`;
      const pNode = grps.get(c);

      if (pNode) {
        if (pNode.nameIsGroup && names[n]) {
          pNode.name = names[n];
          pNode.nameIsGroup = false;
        }

        if (pNode.icon == null && icons[n]) {
          pNode.icon = icons[n];
        }
      }
    }
  } // if ( node.nameIsGroup && !nameIsGroup ) { 
  //   console.log( 'setting node name to explicit', names[len-1])
  //   node.name = names[len - 1] 
  //   node.nameIsGroup = false
  // }
  // if ( node.icon === null && icons != null && icons[len - 1] ) { 
  //   node.icon = icons[len - 1] 
  // }


  return node;
}

function toTree(refs) {
  const grps = new Map();
  const root = {
    type: NODE_TYPE,
    name: null,
    icon: null,
    items: []
  };
  grps.set('', root);

  for (let n = 0; n < refs.length; n++) {
    const g = ensurePath(grps, refs[n].group, refs[n].groupNames, refs[n].groupIcons);
    g.items.push(refs[n].item);
  }

  return root;
}

function defaultSorter(a, b) {
  return a.sort.localeCompare(b.sort);
}

exports.create = create;
exports.NODE_TYPE = NODE_TYPE;